import { HELP_EMAIL, PARTNER_EMAIL } from "@/constants/links";

export default function Contact({ onBookDemo }) {
    return (
        <section className="contact" id="contact" data-testid="v2-contact">
            <div className="container">
                <div className="contact__head reveal">
                    <span className="contact__eyebrow">Get in touch</span>
                    <h2 className="contact__title">
                        Have questions? Talk to us.
                    </h2>
                    <p className="contact__sub">
                        Our team responds within one business day.
                    </p>
                </div>
                <div className="contact__grid">
                    <a
                        className="contact__card reveal"
                        href={`mailto:${HELP_EMAIL}`}
                        data-testid="v2-contact-support"
                    >
                        <div className="contact__icon">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M4 6h16v12H4z" />
                                <polyline points="4 6 12 13 20 6" />
                            </svg>
                        </div>
                        <div className="contact__lbl">Support</div>
                        <div className="contact__val">{HELP_EMAIL}</div>
                    </a>

                    <a
                        className="contact__card reveal"
                        href={`mailto:${PARTNER_EMAIL}`}
                        data-testid="v2-contact-partnerships"
                    >
                        <div className="contact__icon">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <circle cx="9" cy="7" r="4" />
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                        </div>
                        <div className="contact__lbl">Partnerships</div>
                        <div className="contact__val">{PARTNER_EMAIL}</div>
                    </a>
                </div>

                <div className="contact__cta reveal">
                    <button
                        type="button"
                        className="btn btn--primary btn--lg"
                        onClick={onBookDemo}
                        data-testid="v2-contact-book-demo"
                    >
                        Book a demo call
                    </button>
                </div>
            </div>
        </section>
    );
}
